import React, { useEffect } from 'react'
import { useState } from 'react';
import { Button, Card, Col, Divider, Form, Input, InputNumber, Popconfirm, Row, Select, Space, Tooltip, message, Modal, Checkbox, notification, Tabs, Skeleton } from 'antd'
import { useStoreActions, useStoreState } from '../../../../store/hooks/easyPeasy';
import { Table, Tag } from 'antd';
import TableView from '../../../../contents/AntTableResponsive';
import { DeleteOutlined, DownloadOutlined, EditOutlined, SaveOutlined, SearchOutlined } from '@ant-design/icons';
import Column from 'rc-table/lib/sugar/Column';
import { render } from '@testing-library/react';
import { SelectClassConfig } from '../../../select/SelectClassConfig';
import { v4 as uuidv4 } from "uuid";
import $ from 'jquery';
import jsPDF from "jspdf";
import { pdfDataL, ppowerdbypdf, pdatepdf } from '../../../utils/pdf';
import { FilePdfOutlined } from '@ant-design/icons';
import { SelectSection } from '../../../select/SelectSection';
import { SelectAcademicYear } from '../../../select/SelectAcademicYear';
import { SelectClass } from '../../../select/SelectClass';
require('jspdf-autotable');

export default function SectionWiseGradingSummary() {
    const { Option } = Select;
    const [examReportSectionWiseResultForm] = Form.useForm();

    const fetchGradingSummaryExamList = useStoreActions((state) => state.exam.fetchGradingSummaryExamList);
    const examGradingSummaryExamList = useStoreState((state) => state.exam.examGradingSummaryExamList);

    const fetchGradingSummaryByAcademicYearExamidStudentList = useStoreActions((state) => state.exam.fetchGradingSummaryByAcademicYearExamidStudentList);
    const gradingSummaryByAcademicYearExamidStudentList = useStoreState((state) => state.exam.gradingSummaryByAcademicYearExamidStudentList);

    useEffect(() => {
        fetchGradingSummaryExamList();
    }, []);

    const unassignedSubjectMarkListColumn = [
        { title: 'Section', dataIndex: 'sectionName', key: "sectionName", showOnResponse: true, showOnDesktop: true },
        { title: 'Participated In Exam', dataIndex: 'totalStudents', key: "totalStudents", showOnResponse: true, showOnDesktop: true },
        { title: 'Student Roll', dataIndex: 'studentRoll', key: "studentRoll", showOnResponse: true, showOnDesktop: true },
        { title: 'A+', dataIndex: 'numOfAPlus', key: "numOfAPlus", showOnResponse: true, showOnDesktop: true },
        { title: 'A', dataIndex: 'numOfA', key: "numOfA", showOnResponse: true, showOnDesktop: true },
        { title: 'A-', dataIndex: 'numOfAMinus', key: "numOfAMinus", showOnResponse: true, showOnDesktop: true },
        { title: 'B', dataIndex: 'numOfB', key: "numOfB", showOnResponse: true, showOnDesktop: true },
        { title: 'C', dataIndex: 'numOfC', key: "numOfC", showOnResponse: true, showOnDesktop: true },
        { title: 'D', dataIndex: 'numOfD', key: "numOfD", showOnResponse: true, showOnDesktop: true },
        { title: 'F', dataIndex: 'numOfF', key: "numOfF", showOnResponse: true, showOnDesktop: true },
    ];
    const loading = useStoreState((state) => state.exam.loading);

    function exportPdf() {

        var doc = new jsPDF("p", "mm", "a4");

        var details = `Section Wise Grading Summary`;
        pdfDataL(doc, "");
        doc.text(details, 105, 40, 'center');
        var totalPagesExp = "{total_pages_count_string}";

        var pageContent = function (data) {
            // FOOTER
            var str = ppowerdbypdf + data.pageCount;
            if (typeof doc.putTotalPages === 'function') {
                str = str + " of " + totalPagesExp + pdatepdf;
            }
            doc.setFontSize(8);
            var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
            doc.text(str, data.settings.margin.right, pageHeight - 10);
        };


        var col = [
            "Section",
            "Participated In Exam",
            "A+",
            "A-",
            "A",
            "B",
            "C",
            "D",
            "F",
        ].filter(Boolean);

        var rows: any = [];


        gradingSummaryByAcademicYearExamidStudentList.forEach(element => {
            var temp: any = [
                element.sectionName,
                element.totalStudents,
                element.numOfAPlus,
                element.numOfA,
                element.numOfAMinus,
                element.numOfB,
                element.numOfC,
                element.numOfD,
                element.numOfBF
            ];
            rows.push(temp);
        });


        let first = doc.autoTable.previous;
        doc.autoTable([
            { title: "", dataKey: "b1" },
            { title: "", dataKey: "b2" },
            { title: "", dataKey: "b3" },
            { title: "", dataKey: "b4" },
        ], [
            {
                b1: "Academic Year",
                b2: $(".yearSelect").text(),
                b3: 'Exam',
                b4: $(".examSelectx").text(),
            }
        ], {
            startY: 45,
            showHeader: "never",
            theme: 'grid',

            // addPageContent: pageContent,
        });
        doc.autoTable(col, rows, {
            startY: doc.autoTable.previous.finalY + 5,
            showHeader: "firstPage",
            theme: 'grid',
            headerStyles: {
                // fillColor: [105, 105, 105],
                // textColor: [255, 255, 255],
                // fontSize: 10
                lineWidth: .01,
                lineColor: [224, 224, 224]
            },
            styles: {
                overflow: 'linebreak',
                columnWidth: 'noWrap',
            },
            columnStyles: {

            },


        });


        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp);
        }
        doc.setPage(1 + doc.internal.getCurrentPageInfo().pageNumber - doc.autoTable.previous.pageCount);
        doc.save(details + ".pdf");

    }

    const failedExamReport = (value) => {
        let postData: any = {
            examId: value.selectExam,
            academicYear: value.sectionYear,
        }
        fetchGradingSummaryByAcademicYearExamidStudentList(postData);
    }

    // const onClassChange = (value) => {
    //     fetchSectionWiseFailedExamListByClassAndClassId(value);

    // }



    return (
        <>
            <Card title="Section Wise Grading Summary">
                <Row>
                    <Col xs={{ span: 24, offset: 0 }} sm={{ span: 24, offset: 0 }} md={{ span: 24 }} lg={{ span: 16, offset: 4 }} xl={{ span: 16, offset: 4 }}>
                        <Form
                            layout="vertical"
                            id="sessionYearInfo"
                            onFinish={failedExamReport}
                            form={examReportSectionWiseResultForm}
                        >
                            <Row>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }} xl={{ span: 10 }}>
                                    <Form.Item
                                        name="sectionYear"
                                        label="Select Year"
                                        className="title-Text"
                                        rules={[
                                            { required: true, message: "Please select year" },
                                        ]}
                                    >
                                        <SelectAcademicYear />
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }} xl={{ span: 10 }}>
                                    <Form.Item
                                        name="selectExam"
                                        label="Select Exam"
                                        className="title-Text"
                                        rules={[
                                            { required: true, message: "Please select exam" },
                                        ]}
                                    >
                                        <Select placeholder="Exam List" style={{ width: "100%" }} className="examSelectx">
                                            {examGradingSummaryExamList ? (
                                                examGradingSummaryExamList.map((type, idx) => (
                                                    <Option key={type.id} value={type.id}>
                                                        {type.name}
                                                    </Option>
                                                ))
                                            ) : (
                                                <Option value="fetching">Fetching exam</Option>
                                            )}
                                        </Select>

                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                                    <Button type="primary" htmlType="submit" icon={<SearchOutlined />} >
                                        Search
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
                <Skeleton loading={loading} paragraph={{ rows: 10 }} />
                <Row style={{ display: gradingSummaryByAcademicYearExamidStudentList.length > 0 ? '' : 'none' }}>
                    <Col xs={{ span: 24, offset: 0 }} sm={{ span: 24, offset: 0 }} md={{ span: 24 }}>
                        <TableView
                            antTableProps={{
                                showHeader: true,
                                columns: unassignedSubjectMarkListColumn,
                                rowKey: "subjectSerial",
                                dataSource: gradingSummaryByAcademicYearExamidStudentList,
                                filterData: gradingSummaryByAcademicYearExamidStudentList,
                                pagination: true,
                                bordered: true
                            }}
                            mobileBreakPoint={768}
                        />
                        <br />
                        <Button type="primary" htmlType="submit" icon={<DownloadOutlined />} onClick={() => exportPdf()} className="float-right">Download</Button>
                    </Col>
                </Row>
            </Card>
        </>
    )

}